import styled from 'styled-components';

const ImageProfile = styled.img`
  ${props => props.size && `
    width: ${props.size}px;
    height: ${props.size}px;
    border-radius: ${props.size / 2}px;
    // margin: 0px;
    padding: 0px;
  ` }
`;

export default ImageProfile;